module.exports = __webpack_public_path__ + "empty-tpl.4278ee157e.png";